const GameTypes = {
  UPDATE_CURRENT_GAME: "UPDATE_CURRENT_GAME",
  REFRESH_CACHE_AND_RELOAD: "REFRESH_CACHE_AND_RELOAD",
};

export default GameTypes;
